import { useState } from 'react';
import toaster from 'utils/toaster';
import aiContextService from '../service';
import { TOAST_CONFIG } from '../constants';

const TOASTS_PREFIX = 'STATIC.PAGES.AI_CONTEXT.TOASTS';

const useVersionPreview = translate => {
    const [preview, setPreview] = useState(null);
    const [loadingPreviewVersionId, setLoadingPreviewVersionId] = useState(null);

    const previewVersion = (version, { onLoaded } = {}) => {
        if (loadingPreviewVersionId != null) return;
        setLoadingPreviewVersionId(version.id);
        aiContextService
            .getVersion(version.id)
            .then(historicalAnswers => {
                setPreview({
                    versionId: version.id,
                    meta: version,
                    answers: historicalAnswers,
                });
                if (onLoaded) onLoaded();
            })
            .catch(() => toaster.error(translate(`${TOASTS_PREFIX}.VERSION_LOAD_FAILED`), TOAST_CONFIG))
            .finally(() => setLoadingPreviewVersionId(null));
    };

    const exitPreview = () => setPreview(null);

    return {
        isPreviewing: preview !== null,
        previewingVersionId: preview?.versionId ?? null,
        previewVersionMeta: preview?.meta ?? null,
        previewAnswers: preview?.answers ?? null,
        loadingPreviewVersionId,
        previewVersion,
        exitPreview,
    };
};

export default useVersionPreview;
